import React from "react";
import { APERTURE_OPTIONS, SHUTTER_OPTIONS, ISO_OPTIONS } from "../../game/rooms";
import ApertureIris from "./ApertureIris";

const DialGroup = ({ label, options, value, onChange, testidPrefix, headerExtra }) => (
    <div role="radiogroup" aria-label={label} className="flex flex-col gap-2">
        <div className="text-[10px] tracking-[0.25em] text-amber uppercase font-mono flex items-center justify-between">
            <span>{label}</span>
            {headerExtra || <span className="text-[var(--text-muted)]">▾</span>}
        </div>
        <div className="grid grid-cols-5 gap-1.5">
            {options.map((opt) => {
                const selected = value?.value === opt.value;
                return (
                    <button
                        key={opt.value}
                        type="button"
                        role="radio"
                        aria-checked={selected}
                        aria-label={`${label} ${opt.label}`}
                        onClick={() => onChange(opt)}
                        className={`dial-btn px-1 py-2 text-[11px] sm:text-xs ${selected ? "selected" : ""}`}
                        data-testid={`${testidPrefix}-${opt.value.replace("/", "-")}`}
                    >
                        {opt.label}
                    </button>
                );
            })}
        </div>
    </div>
);

export const CameraControls = ({ aperture, shutter, iso, onChange, disabled }) => {
    const set = (k) => (v) => { if (!disabled) onChange({ [k]: v }); };

    // Live iris preview reflecting the current aperture selection
    const irisPreview = (
        <span
            className="flex items-center gap-1.5"
            data-testid="aperture-iris-preview"
            aria-label={`Iris preview for ${aperture?.label}`}
        >
            <ApertureIris stops={aperture?.stops ?? 5} size={22} />
        </span>
    );

    return (
        <div className="flex flex-col gap-5" data-testid="camera-controls">
            <DialGroup
                label="Aperture · f-stop"
                options={APERTURE_OPTIONS}
                value={aperture}
                onChange={set("aperture")}
                testidPrefix="aperture"
                headerExtra={irisPreview}
            />
            <DialGroup
                label="Shutter Speed"
                options={SHUTTER_OPTIONS}
                value={shutter}
                onChange={set("shutter")}
                testidPrefix="shutter"
            />
            <DialGroup
                label="ISO · Sensitivity"
                options={ISO_OPTIONS}
                value={iso}
                onChange={set("iso")}
                testidPrefix="iso"
            />
        </div>
    );
};

export default CameraControls;
